import { render, staticRenderFns } from "./BusDepartmentStat.vue?vue&type=template&id=19d82425&scoped=true"
import script from "./BusDepartmentStat.vue?vue&type=script&lang=js"
export * from "./BusDepartmentStat.vue?vue&type=script&lang=js"
import style0 from "./BusDepartmentStat.vue?vue&type=style&index=0&id=19d82425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d82425",
  null
  
)

export default component.exports